"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableTopContent = TableTopContent;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var label_1 = require("../../../controls/label");
var react_3 = require("react");
var paginationContext_1 = require("../../../contexts/paginationContext");
var tableContext_1 = require("../../../contexts/tableContext");
function TableTopContent(_a) {
    var _b = _a === void 0 ? {} : _a, filters = _b.filters, actions = _b.actions, _c = _b.searchable, searchable = _c === void 0 ? true : _c;
    // const { filterActions, isFiltersPopoverOpen, onApplyFilters, onClearFilters, onCloseFilterPopover, onOpenFilterPopover } = useFiltersContext();
    var setPage = (0, paginationContext_1.usePaginationContext)().setPage;
    var _d = (0, tableContext_1.useTableContext)(), tableTitle = _d.tableTitle, compact = _d.compact, actionButtons = _d.actionButtons, isSearchBusy = _d.isSearchBusy, onSearchChanged = _d.onSearchChanged;
    // const handleApplyFilters = useCallback(() => {
    //   onApplyFilters();
    // }, [onApplyFilters]);
    // const handleClearFilters = useCallback(() => {
    //   onClearFilters();
    // }, [onClearFilters]);
    // const handleOpenChanged = useCallback(() => {
    //   if (!isFiltersPopoverOpen) {
    //     onOpenFilterPopover();
    //   } else {
    //     onCloseFilterPopover();
    //   }
    // }, [isFiltersPopoverOpen, onCloseFilterPopover, onOpenFilterPopover]);
    var handleSearch = (0, react_3.useCallback)(function (searchString) {
        onSearchChanged(searchString);
        if (searchString === "") {
            setPage(1);
        }
    }, [onSearchChanged, setPage]);
    // const handleSortChanged = useCallback(
    //   (item: any) => () => {
    //     onSortChanged({
    //       column: item.uid,
    //       direction: sortDescriptor.direction === "ascending" ? "descending" : "ascending",
    //     });
    //   },
    //   [],
    // );
    // const handleVisibleColumnsChanged = useCallback(
    //   (keys: SharedSelection) => {
    //     console.log(keys);
    //     const visibleColumns = [];
    //     const keysArray = Array.from(keys);
    //     for (let i = 0; i < keysArray.length; i++) {
    //       visibleColumns.push(keysArray[i]);
    //     }
    //     setTableConfig({ ...tableColumnConfig, visibleColumns: visibleColumns as any });
    //     onVisibleColumnsChanged(keys);
    //   },
    //   [onVisibleColumnsChanged, setTableConfig, tableColumnConfig],
    // );
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-wrap items-center gap-3 ".concat(compact ? "mb-2" : "mb-4"), children: [searchable && ((0, jsx_runtime_1.jsxs)(react_1.InputGroup, { className: compact ? "min-w-[180px] max-w-[240px]" : "min-w-[220px] max-w-[300px]", children: [(0, jsx_runtime_1.jsx)(react_1.InputGroup.Prefix, { children: isSearchBusy ? (0, jsx_runtime_1.jsx)(react_1.Spinner, { color: "accent", size: "sm" }) : (0, jsx_runtime_1.jsx)(react_2.Icon, { className: "text-muted", icon: "solar:magnifer-linear", width: 16 }) }), (0, jsx_runtime_1.jsx)(react_1.InputGroup.Input, { placeholder: "Search", onChange: function (event) { return handleSearch(event.target.value); } })] })), tableTitle && (0, jsx_runtime_1.jsx)(label_1.Label, { label: tableTitle, size: compact ? "small" : "large", bold: true, textColor: "text-black" }), filters, (0, jsx_runtime_1.jsxs)("div", { className: "ml-auto flex items-center gap-3", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex items-center justify-start gap-4" }), Boolean(actionButtons === null || actionButtons === void 0 ? void 0 : actionButtons.length) && ((0, jsx_runtime_1.jsx)("div", { className: "flex justify-end gap-4", children: actionButtons === null || actionButtons === void 0 ? void 0 : actionButtons.map(function (button, index) {
                            var _a;
                            return ((0, jsx_runtime_1.jsxs)(react_1.Button, { variant: (_a = button.variant) !== null && _a !== void 0 ? _a : "primary", onPress: button.onClick, children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: button.iconClassname, width: 20 }), button.label] }, index));
                        }) })), actions] })] }));
}
